import { AllowedHours } from './access-hours.model'
import { CLIENT_ID, ModulesType } from './client.model'
import { Role, ROLE_ID } from './role.model'

export type USER_ID = string | number
export class User {
  id: USER_ID
  client_id: number
  full_name: string
  user_name: string
  password: string
  role?: Role
  role_id: ROLE_ID
  permission_name: string
  country_code: string
  mobile: string
  email: string
  technician: boolean
  prefs: string
  active: boolean
  image: string
  approver_requirement_ids?: number[]
  client_role_ids?: number[]
  // SAML fields
  auth_method?: 'SAML' | 'STANDARD' = 'STANDARD'
  saml_id?: string | null = null // SAML NameID from IdP
  last_saml_login?: Date | null = null
  // Time-based access control
  allowed_hours?: AllowedHours | null = null // JSON field, see AllowedHours
}

export class CreateUserInput {
  client_id: CLIENT_ID = NaN
  full_name: string = ''
  user_name: string = ''
  password: string = ''
  event_ids?: Array<number> | null = null
  /** One of the client's roles (YB-2166). */
  role_id: ROLE_ID | null = null
  country_code: string = ''
  mobile: string = ''
  email: string = ''
  technician: boolean = false
  prefs: string = ''
  active: boolean = false
  image: string = ''
  approver_requirement_ids?: number[] = []
  client_role_ids?: number[] = []
  allowed_hours?: AllowedHours | null = null
}

export class UpdateUserInput {
  id: USER_ID = NaN
  client_id: CLIENT_ID = NaN
  full_name?: string = ''
  user_name?: string = ''
  password?: string = ''
  event_ids?: Array<number> | null = null
  /** One of the client's roles (YB-2166). Unchanged when it is the user's current role. */
  role_id?: ROLE_ID | null = null
  country_code?: string = ''
  mobile?: string = ''
  email?: string = ''
  technician?: boolean = false
  prefs?: string = ''
  active?: boolean = false
  image: string = ''
  approver_requirement_ids?: number[] = []
  client_role_ids?: number[] = []
  allowed_hours?: AllowedHours | null = null
}

export class UserPrefs {
  client_id: number = NaN
  id: number = NaN
  darkMode: boolean = false
  showPassNames: boolean = false
  KPIs: string = ''
  language: string = ''
  currentModule: ModulesType = 'SportsAndCulture'
  category: Array<string> = []
  entryMonitorTimeWindow: string = '30'
  /** Entry Control favorite stations (YB-2271): comma-separated station ids. */
  entryControlFavorites: string = ''
  /** Entry Control stations panel tab (YB-2271): 'favorites' | 'all', empty until the user picks one. */
  entryControlTab: string = ''
  collapsedEntrances: string = '{}'
  /** Bookings calendar day/week toggle (YB-2066). Empty until the admin picks a side. */
  bookingsCalendarMode: string = ''
  currentView: string = `
  [{
    module: 'Kindergarten',
    view: 'row'
  },
  {
    module: 'Visitors',
    view: 'row'
  },
  {
    module: 'SportsAndCulture',
    view: 'row'
  },
  {
    module: 'Timewatch',
    view: 'row'
  },
  {
    module: 'Kindergarten',
    view: 'row'
  },
  {
    module: 'Authorized',
    view: 'row'
  },
  {
    module: 'Authorized',
    view: 'row'
  },
  {
    module: 'Timewatch',
    view: 'row'
  },
  {
    module: 'Courses',
    view: 'row'
  }
]`
}
